// removed by extract-text-webpack-plugin
module.exports = {"icon":"Date__icon___1w9Q2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Date/Date.scss
// module id = 1220
// module chunks = 1